import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/rights`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getAllRights({commit}) {
    return axiosInstance.get(`${baseUrl}`)
      .then((data) => data.data);
  },
  getCompanyDefaultRights({commit}, payload: { companyId: number, type: string }) {
    return axiosInstance.get(`${baseUrl}/${payload.companyId}/default-rights/${payload.type}`)
      .then((data) => data.data);
  },
  getUserRightsById({commit}, payload: { userId: number, companyId: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.userId}/user-rights/${payload.companyId}`)
      .then((data) => data.data);
  },
  saveCompanyDefaultRights({commit}, payload: {
    companyId: number,
    type: string,
    rights: number[],
    applyToExistingUsers: boolean,
  }) {
    return axiosInstance.put(`${baseUrl}/${payload.companyId}/default-rights/${payload.type}`, {
      rights: payload.rights,
      applyToExistingUsers: payload.applyToExistingUsers,
    })
      .then((data) => data.data);
  },
  saveUserRights({commit}, payload: { userId: number, companyId: number, rights: number[] }) {
    return axiosInstance.put(`${baseUrl}/${payload.userId}/update-user-rights`, {
      companyId: payload.companyId,
      rights: payload.rights,
    })
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
